import { defineMessages } from 'react-intl';

export default defineMessages({
1:{
id: 'quoteandbind.PPLProLinedirectives.templates.AtFaultaccidents.#',
defaultMessage: '#'
},
datOfAcc2:{
id: 'quoteandbind.PPLProLinedirectives.templates.AtFaultaccidents.Date of Accident',
defaultMessage: 'Date of Accident'
},
des3:{
id: 'quoteandbind.PPLProLinedirectives.templates.AtFaultaccidents.Description',
defaultMessage: 'Description'
},
removeAccident:{
id: 'quoteandbind.PPLProLinedirectives.templates.AtFaultaccidents.Remove Accident',
defaultMessage: 'Remove Accident {accDesc}'
},
addAccident:{
id: 'quoteandbind.PPLProLinedirectives.templates.AtFaultaccidents.Add Accident',
defaultMessage: 'Add At fault Accident'
},
});